import { RouteConfig } from 'vue-router';
import CompanyProfile from '@/views/default/CompanyProfile.vue';
import Userprofile from '@/views/default/Userprofile.vue';
import Employees from '@/views/usermanagment/Employees.vue';
import Companies from '@/views/usermanagment/Companies.vue';
import CompanyVariables from '@/views/usermanagment/CompanyVariables.vue';
import InsuranceProfile from '@/views/default/InsuranceProfile.vue';
import TextTemplates from '@/views/usermanagment/TextTemplates.vue';
import TextTemplateEdit from '@/views/usermanagment/TextTemplateEdit.vue';
import OpeningHours from '@/views/management/RepairShop/OpeningHours.vue';
import PageModal from '@/components/modals/PageModal.vue';
import Vacations from '@/views/usermanagment/Vacation/Vacations.vue';
import AddVacationModal from '@/views/usermanagment/Vacation/AddVacationModal.vue';
import Forms from '@/views/usermanagment/Forms/Forms.vue';
import FormEdit from '@/views/usermanagment/Forms/FormEdit.vue';
import ManagePayment from '@/views/management/RepairShop/Sales/ManagePayment.vue';
import AccountSettings from '@/views/default/AccountSettings.vue';
import ContractManagement from '@/views/management/Contracts/ContractManagement.vue';
import PDFBlueprintsOverview from '@/views/pdfblueprints/PDFBlueprintsOverview.vue';
import PDFBlueprintsEdit from '@/views/pdfblueprints/PDFBlueprintsEdit.vue';
import DocumentDefinitionsOverview from '@/views/documentdefinitions/DocumentDefinitionsOverview.vue';
import DocumentDefinitionsEdit from '@/views/documentdefinitions/DocumentDefinitionsEdit.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/employees',
		name: 'employees',
		component: Employees,
	},
	{
		path: '/vacations',
		name: 'vacations',
		component: Vacations,
		children: [
			{
				path: 'create_vacation/:id?',
				name: 'vacations.create_vacation',
				component: PageModal,
				props: {
					component: AddVacationModal,
					title: 'Abwesenheitszeitraum hinterlegen',
					saveButtonText: 'Speichern',
					modalStyle: 'width: fit-content; align-self: center',
					props: true,
				},
			},
		],
	},
	{
		path: '/contract-management',
		name: 'ContractManagement',
		component: ContractManagement,
	},
	{
		path: '/forms',
		name: 'forms',
		component: Forms,
	},
	{
		path: '/forms/:id',
		name: 'forms.edit',
		component: FormEdit,
	},
	{
		path: '/userprofile',
		name: 'Userprofile',
		component: Userprofile,
	},
	{
		path: '/userprofile/new',
		name: 'NewUserprofile',
		component: Userprofile,
		meta: {
			action: 'new',
		},
	},
	{
		path: '/userprofile/:id',
		name: 'OtherUserprofile',
		component: Userprofile,
	},
	{
		path: '/accountsettings',
		name: 'AccountSettings',
		component: AccountSettings,
	},
	{
		path: '/companyprofile',
		name: 'CompanyProfile',
		component: CompanyProfile,
	},
	{
		path: '/managepayment',
		name: 'ManagePayment',
		component: ManagePayment,
	},
	{
		path: '/openinghours',
		name: 'OpeningHours',
		component: OpeningHours,
	},
	{
		path: '/pdf-blueprints',
		name: 'PdfBlueprintsOverview',
		component: PDFBlueprintsOverview,
	},
	{
		path: '/pdf-blueprints/:id',
		name: 'PdfBlueprintsEdit',
		component: PDFBlueprintsEdit,
	},
	{
		path: '/document-definitions',
		name: 'DocumentDefinitionsOverview',
		component: DocumentDefinitionsOverview,
	},
	{
		path: '/document-definitions/:key',
		name: 'DocumentDefinitionsEdit',
		component: DocumentDefinitionsEdit,
	},
	{
		path: '/companyprofile/:type/new',
		name: 'administrate_new_companies',
		component: CompanyProfile,
		meta: {
			action: 'new',
		},
	},
	{
		path: '/companyprofile/:type/:id',
		name: 'OtherCompanyProfile',
		component: CompanyProfile,
	},
	{
		path: '/insurances/:id',
		name: 'insurancesprofile',
		component: InsuranceProfile,
	},
	{
		path: '/companies/:type',
		name: 'administrate_companies',
		component: Companies,
	},
	{
		path: '/companyprofile/:type/:id/employees',
		name: 'company_employees',
		component: Employees,
	},
	{
		path: '/companyvariables',
		name: 'companyvariables',
		component: CompanyVariables,
	},
	{
		path: '/text_templates',
		name: 'text_templates',
		component: TextTemplates,
		meta: {
			levelGuard: [1],
		},
	},
	{
		path: '/text_templates/:id',
		name: 'text_templates.edit',
		component: TextTemplateEdit,
		meta: {
			levelGuard: [1],
		},
	},
];

/*routes.map(route => {
	route.meta = route.meta || {};
	route.meta.levelGuard = [1, 2];
});*/

export default routes;
